// Spanish navigation data — mirrors navData.ts shape with Spanish labels and /es/* links.
import type { NavLink, NavEntry } from "@/components/navData";

import type { NavGroup } from "@/components/navData";

export type { NavLink, NavEntry } from "@/components/navData";
export type { NavGroup };

export const isGroup = (e: NavEntry): e is NavGroup =>
  (e as { type?: string }).type === "group";

export const esTreatmentEntries: NavEntry[] = [
  { label: "SAINT®", href: "/es/saint", isRoute: true, featured: true },
  {
    label: "Protocolo acelerado de un día Ampa",
    href: "/es/ampa",
    isRoute: true,
    featured: true,
  },
  {
    type: "group" as const,
    label: "TMS",
    children: [
      { label: "TMS", href: "/es/services/tms", isRoute: true },
      {
        label: "TMS para depresión",
        href: "/es/services/depression",
        isRoute: true,
      },
      {
        label: "TMS para ansiedad",
        href: "/es/services/anxiety",
        isRoute: true,
      },
      { label: "TMS para TEPT", href: "/es/services/ptsd", isRoute: true },
      { label: "TMS para TOC", href: "/es/services/ocd", isRoute: true },
    ],
  },
  {
    type: "group" as const,
    label: "Ketamina",
    children: [
      {
        label: "Terapia de ketamina IV",
        href: "/es/ketamine-treatment-coral-springs-fl",
        isRoute: true,
      },
      {
        label: "Ketamina para ansiedad",
        href: "/es/anxiety-treatment-coral-springs-fl",
        isRoute: true,
      },
      {
        label: "Ketamina para depresión",
        href: "/es/depression-treatment-coral-springs-fl",
        isRoute: true,
      },
      {
        label: "Ketamina para TEPT",
        href: "/es/ptsd-treatment-coral-springs-fl",
        isRoute: true,
      },
      {
        label: "Ketamina para TOC",
        href: "/es/ocd-treatment-coral-springs-fl",
        isRoute: true,
      },
      {
        label: "Ketamina para dolor crónico",
        href: "/es/chronic-pain-coral-springs-fl",
        isRoute: true,
      },
      {
        label: "Psicoterapia asistida con ketamina",
        href: "/es/ketamine-assisted-psychotherapy-coral-springs-fl",
        isRoute: true,
      },
    ],
  },
  { label: "SPRAVATO®", href: "/es/spravato", isRoute: true },
  { label: "Psiquiatría", href: "/es/services/psychotherapy", isRoute: true },
  {
    label: "Manejo de medicación",
    href: "/es/services/medication-management",
    isRoute: true,
  },
  {
    label: "PrTMS y mapeo cerebral",
    href: "/prtms-therapy-coral-springs-fl",
    isRoute: true,
  },
  { label: "Prism para TEPT", href: "/prism", isRoute: true },
  { label: "Proliv®Rx TMS en casa", href: "/prolivrx", isRoute: true },
];

export const esPracticeEntries: NavEntry[] = [
  { label: "Sobre nosotros", href: "/es/about", isRoute: true },
  {
    label: "Referencia de proveedores",
    href: "/patient-eligibility-checklist",
    isRoute: true,
  },
  {
    label: "Información del paciente",
    href: "/contents/patient-info",
    isRoute: true,
  },
  {
    label: "Costo y seguro",
    href: "/es/saint-tms-insurance-coverage",
    isRoute: true,
  },
  {
    type: "group" as const,
    label: "Seguros",
    children: [
      {
        label: "Aetna",
        href: "/es/insurance/aetna-insurance",
        isRoute: true,
      },
      {
        label: "Cigna",
        href: "/es/insurance/cigna-insurance",
        isRoute: true,
      },
      {
        label: "UnitedHealthcare",
        href: "/es/insurance/unitedhealthcare-insurance",
        isRoute: true,
      },
      {
        label: "Florida Blue",
        href: "/es/insurance/florida-blue-insurance",
        isRoute: true,
      },
      {
        label: "Anthem Blue Cross",
        href: "/es/insurance/anthem-blue-cross-insurance",
        isRoute: true,
      },
      {
        label: "BCBS de Illinois",
        href: "/es/insurance/bcbsil-insurance",
        isRoute: true,
      },
      {
        label: "Ambetter",
        href: "/es/insurance/ambetter-insurance",
        isRoute: true,
      },
      {
        label: "Oscar",
        href: "/es/insurance/oscar-insurance",
        isRoute: true,
      },
    ],
  },
  { label: "Empleos", href: "/careers", isRoute: true },
];

export const esResourcesEntries: NavLink[] = [
  { label: "Educación para pacientes", href: "/es/learn", isRoute: true },
  { label: "Artículos", href: "/articles", isRoute: true },
  {
    label: "Videos y medios",
    href: "/contents/patient-info/videos-media",
    isRoute: true,
  },
];

export const esOtherLinks: NavLink[] = [
  { label: "Contáctenos", href: "/es/contactus", isRoute: true },
];

export const esNavLabels = {
  announcement:
    "El único proveedor ambulatorio verificado de SAINT® TMS en la Costa Este",
  patientPortal: "Portal del paciente",
  treatments: "Tratamientos",
  ourPractice: "Nuestra clínica",
  resources: "Recursos",
  contactUs: "Contáctenos",
  call: "Llamar",
  callNumber: "954-827-9793",
};
